import { fromActionPrefixId } from "features/Resources/Shared/helpers";
import { ActionType, PrefixId } from "features/Resources/Shared/models";

type ResourceIdKey = `${ActionType}Id`;

export function actionIdObjectFromPrefixId(prefixId: PrefixId): Record<ResourceIdKey, string | number> {
  const { resourceType, id } = fromActionPrefixId(prefixId);

  const key = `${resourceType}Id` as ResourceIdKey;

  return {
    [key]: id,
  };
}
